import {BaseService} from "./BaseService";
import {BearerApiClient} from "./APIClient";
import {PaginatedResponse} from "../types/PaginatedResponse";
import * as queryString from "query-string";
import {paginatedRequestQuery} from "../helper/paginatedRequest";
import {ServiceMethodOptions} from "../helper/PagingController";
import {TypeId} from "../types/TypeId";
import {Driver} from "../models/Driver";


interface GetAllQueryOptions  {
    search?: string;
}

export class DriverService extends BaseService {

    public async getAll(options: ServiceMethodOptions, queryOptions: GetAllQueryOptions) {
        const client = BearerApiClient();

        const qs = queryString.stringify({
            ...paginatedRequestQuery(options),
            ...queryOptions,
        })

        return this.response<PaginatedResponse<Driver>>(
            client.get(this.BASE_URL + "/drivers?" + qs, {
                signal: options.abortSignal
            }),
        )
    }

    public async delete(id: TypeId) {
        const client = BearerApiClient();

        return this.response<Driver>(
            client.delete(this.BASE_URL + `/drivers/${id}`),
        )
    }

    public async get(id: TypeId) {
        const client = BearerApiClient();

        return this.response<Driver>(
            client.get(this.BASE_URL + `/drivers/${id}`)
        )
    }

    public async create(payload: Partial<Driver>) {
        const client = BearerApiClient();

        return this.response<Driver>(
            client.post(this.BASE_URL + `/drivers`, payload)
        )
    }

    public async update(id: TypeId, payload: Partial<Driver>) {
        const client = BearerApiClient();

        return this.response<Driver>(
            client.put(this.BASE_URL + `/drivers/${id}`, payload)
        )
    }

}